import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import type { AuthState } from "../auth/AuthProvider";
import { consumeSessionExpired } from "../auth/performSignOut";
import { PhoneStep } from "../login/PhoneStep";
import { CodeStep } from "../login/CodeStep";

function LoginRoute() {
  return <LoginScreen auth={Route.useRouteContext().auth} />;
}

export const Route = createFileRoute("/login")({
  component: LoginRoute,
});

// Exported for tests (rendered without a router).
export function LoginScreen({ auth }: { auth: AuthState }) {
  const navigate = useNavigate();
  const [phone, setPhone] = useState<string | null>(null);
  // Read (and clear) once on mount — a double-401 elsewhere in the app flags this so the
  // reason for landing back here is explained, but only the once (spec §6).
  const [sessionExpired] = useState(() => consumeSessionExpired());

  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white px-6 py-8 shadow-sm">
        {sessionExpired && (
          <p className="mb-4 text-sm text-amber-600">Your session expired — please sign in again.</p>
        )}
        {phone === null ? (
          <PhoneStep onSent={setPhone} />
        ) : (
          <CodeStep
            phone={phone}
            auth={auth}
            onBack={() => setPhone(null)}
            onSignedIn={() => navigate({ to: "/home" })}
          />
        )}
      </div>
    </main>
  );
}
